import { z } from "zod";
import { emailSchema, otpCodeSchema } from "../../utils/validation.js";
export const requestOtpSchema = z.object({
    email: emailSchema,
});
export const verifyOtpSchema = z.object({
    email: emailSchema,
    code: otpCodeSchema,
});
